import { Splide, SplideSlide } from '@splidejs/react-splide';
import styled from 'styled-components';

import { grey10 } from 'constants/variables';
import ContentfulImageRenderer from './image_renderer';

import slideNumber from './carousel_slide_number';

const ImageCarousel = ({ content: { images } }) =>
  images?.length > 0 && (
    <div className="contentful__carousel contentful__carousel--with-caption">
      <Splide
        options={{ pagination: false }}
        hasTrack={false}
        className="splide fl fl-col-reverse ai-fe"
        role="group"
        aria-label="product image carousel"
        extensions={{ slideNumber }}>
        <PageImageContentWrapper className="splide__track mb-16 pb-32">
          <ul className="splide__list">
            {images.map((image, i) => (
              <SplideSlide
                className={`similar-stock-carousel__item splide__slide
                    splide__slide--${i}`}
                key={image.sys.id}
                data-testid="splide__slide--similarstock-item">
                <ContentfulImageRenderer image={image} />
                {image.fields.description && (
                  <p className="evergreen__container__image_carousel-media-caption fs-12 mt-16 tc-secondary">
                    {image.fields.description}
                  </p>
                )}
              </SplideSlide>
            ))}
          </ul>
        </PageImageContentWrapper>
      </Splide>
    </div>
  );

const PageImageContentWrapper = styled.div`
  border-bottom: 2px solid ${grey10};
`;

export default ImageCarousel;
